import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ConditionModel } from '@libs/form/models';
import { ConditionEvaluator, EqualConditionEvaluator } from './evaluator';

@Injectable()
export class ConditionEvaluatorFactory {
  public create(control: AbstractControl, condition: ConditionModel): ConditionEvaluator | undefined {
    let evaluator: ConditionEvaluator;

    switch (condition.operator) {
      case 'equal':
        evaluator = new EqualConditionEvaluator(control, condition.value);

        break;
    }

    return evaluator;
  }
}
